export const CLICK = 'Payer Onboarding. Log in click.'
